import type { FC } from 'react';
import { Box, Stack, Tooltip } from '@mui/material';

import { getContrastColor } from 'src/helper/getContrastColor';

import type { PillProps } from '../Pill/Pill';
import Pill from '../Pill/Pill';

import BarSegment from './BarSegment';

interface BarWithPillProps {
  type: 'vertical' | 'horizontal';
  label?: string;
  relativeSize: number;
  pill?: PillProps;
  borderPosition: 'Right' | 'Left' | 'Top' | 'Bottom';
  color: string;
  borderColor: string;
  withGradient?: boolean;
  borderWidth?: number;
  toolTip?: string;
  maxWidth?: string | number;
  dontOverwritePillBg?: boolean;
  noDataAvailable?: boolean;
}

const BarWithPill: FC<BarWithPillProps> = ({
  type,
  pill,
  color,
  borderColor,
  relativeSize,
  borderPosition,
  label,
  withGradient,
  borderWidth = 2,
  toolTip,
  maxWidth,
  dontOverwritePillBg,
  noDataAvailable,
}) => {
  const direction = type === 'horizontal' ? 'row' : 'column';

  return (
    <Tooltip title={toolTip}>
      <Stack
        direction={direction === 'row' ? `${direction}-reverse` : direction}
        sx={{
          height: '100%',
          flexGrow: 1,
          justifyContent: direction === 'row' ? 'start' : 'end',
          maxWidth: maxWidth,
        }}
      >
        {pill ? (
          <Stack
            direction={direction === 'row' ? `${direction}-reverse` : direction}
            sx={{
              alignItems: 'center',
            }}
          >
            <Pill
              {...pill}
              sx={
                !dontOverwritePillBg
                  ? {
                      backgroundColor: borderColor,
                      color: getContrastColor(borderColor),
                    }
                  : undefined
              }
            />
            <Box
              sx={{
                borderColor: borderColor,
                width: '10px',
                height: '10px',
                borderRadius: '50%',
                borderWidth: '2px',
                borderStyle: 'solid',
              }}
            />
          </Stack>
        ) : null}

        <BarSegment
          color={color}
          label={label}
          borderPosition={borderPosition}
          type={type}
          borderColor={borderColor}
          relativeSize={relativeSize}
          borderWidth={borderWidth}
          withGradient={withGradient}
          noDataAvailable={noDataAvailable}
        />
      </Stack>
    </Tooltip>
  );
};

export default BarWithPill;
